import { render, staticRenderFns } from "./HeatlthServices.vue?vue&type=template&id=2183ac28&"
import script from "./HeatlthServices.vue?vue&type=script&lang=js&"
export * from "./HeatlthServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2183ac28')) {
      api.createRecord('2183ac28', component.options)
    } else {
      api.reload('2183ac28', component.options)
    }
    module.hot.accept("./HeatlthServices.vue?vue&type=template&id=2183ac28&", function () {
      api.rerender('2183ac28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Filters/Headers/HeatlthServices.vue"
export default component.exports